// Barra fija al pie con lo seleccionado y la acción de eliminar.
import React from "react";
import { Button, Typography } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { MAX_IDS_POR_OPERACION } from "../../../services/almacenamiento.api";
import { formatPeso } from "../almacenamientoUtils";

const { Text } = Typography;

interface Props {
  cantidad: number;
  bytes: number;
  /** Cuántos archivos tiene el filtro vigente (para ofrecer seleccionarlos todos). */
  totalFiltro: number;
  seleccionandoTodo: boolean;
  onSeleccionarFiltro: () => void;
  onEliminar: () => void;
  onLimpiar: () => void;
}

const BarraSeleccion: React.FC<Props> = ({
  cantidad,
  bytes,
  totalFiltro,
  seleccionandoTodo,
  onSeleccionarFiltro,
  onEliminar,
  onLimpiar,
}) => {
  if (cantidad === 0) return null;
  const faltan = totalFiltro > cantidad;
  return (
    <div className="alm-barra-sel" role="region" aria-label="Archivos seleccionados" aria-live="polite">
      <div className="alm-barra-sel-texto">
        <Text strong>
          {cantidad.toLocaleString("es-CL")} {cantidad === 1 ? "seleccionado" : "seleccionados"}
        </Text>
        <Text>
          {" "}
          · liberarías <Text strong>{formatPeso(bytes)}</Text>
        </Text>
        {cantidad >= MAX_IDS_POR_OPERACION && (
          <Text type="warning"> · tope por vez: {MAX_IDS_POR_OPERACION}</Text>
        )}
      </div>
      <div className="alm-barra-sel-acciones">
        {faltan && cantidad < MAX_IDS_POR_OPERACION && (
          <Button
            className="alm-btn-tactil"
            loading={seleccionandoTodo}
            onClick={onSeleccionarFiltro}
          >
            Seleccionar los {Math.min(totalFiltro, MAX_IDS_POR_OPERACION)} del filtro
          </Button>
        )}
        <Button className="alm-btn-tactil" onClick={onLimpiar} disabled={seleccionandoTodo}>
          Limpiar selección
        </Button>
        <Button
          className="alm-btn-tactil"
          type="primary"
          danger
          icon={<DeleteOutlined />}
          onClick={onEliminar}
          disabled={seleccionandoTodo}
        >
          Eliminar
        </Button>
      </div>
    </div>
  );
};

export default BarraSeleccion;
